import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { createAuthGuard, AuthGuardData } from 'keycloak-angular';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;
  const router = inject(Router);

  // 1. Si no está autenticado, Keycloak lo mandará al login automáticamente
  if (!authenticated) {
    return false; 
  }

  // 2. Obtenemos los roles requeridos de la ruta (ahora soporta varios roles)
  const requiredRoles = route.data['roles'] as string[];
  if (!requiredRoles || requiredRoles.length === 0) {
    return true; // Si no pide roles, cualquiera logueado entra
  }

  // 3. CAMBIO CLAVE: Buscamos en REALM ROLES (no resourceRoles)
  const hasRole = requiredRoles.some((role) => 
    grantedRoles.realmRoles.includes(role)
  );

  if (hasRole) {
    return true;
  }

  // 4. Sin acceso: operario va a /orden-retiro, el resto al dashboard
  const isOperario = grantedRoles.realmRoles.includes('operario');
  return router.parseUrl(isOperario ? '/orden-retiro' : '/dashboard');
};

export const canActivateAuthRole = createAuthGuard(isAccessAllowed);